/*
 * 信审后台人员管理列表 *
 * *
 * */

import {
  GetUserListReq,
  BatchUpdateUserWorkStatusReq
} from "@/pbjs/external/user/user_pb";
import {
  ListUserGroupByTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { userClient } from "@/api/userClient";
import { authorClient } from "@/api/authorClient"
import { Page, timeFormat } from "@/utils/index";
import { setCommon, setPage } from "@/utils/request";
import InnerRequest from "./request";
export interface Options {
  inputName?: string;
  inputEmail?: string;
  roleValue?: string;
  userStatus?: number;
  userId?: number;
  employeeId?: string;
  twoFactAuthRange?: number;
  outSourceRange?: number;
  attendancetimefrom?: string;
  attendancetimeto?: string;
  workstatus?: string,
  execType?: number;
  Page: Page;
}
export interface batchOptions {
  selectionList?: number[];
  userWorkStatus?: string;
}
export function setGetUserListReq(arg: Options) {
  let request: any = new GetUserListReq();
  request.setCommonin(setCommon());
  request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
  request.setName(arg.inputName); //员工姓名
  request.setEmail(arg.inputEmail);
  request.setUsergroup(arg.roleValue);//员工角色
  request.setAttendancetimefrom(arg.attendancetimefrom);
  request.setAttendancetimeto(arg.attendancetimeto);
  request.setUserid(arg.userId);//员工ID
  request.setEmployeeid(arg.employeeId);
  request.setTwofactauthrange(arg.twoFactAuthRange);
  request.setOutsourcerange(arg.outSourceRange);
  request.setUserstatusrange(arg.userStatus);
  request.setWorkstatus(arg.workstatus); //员工类型
  request.setExectype(arg.execType);
  return request;
}
export function setListUserGroupByTypeReq(arg: Options) {
  let request: any = new ListUserGroupByTypeReq();
  request.setCommonin(setCommon());
  request.setExectype(arg.execType); //员工角色
  return request; 
 
  
}

export function setBatchUpdateUserWorkStatusReq(arg: batchOptions) {
  let request: any = new BatchUpdateUserWorkStatusReq();
  request.setCommonin(setCommon());
  request.setStatus(arg.userWorkStatus);
  request.setUseridList(arg.selectionList);
  return request;
}
// 查询列表
export const getUserListRequest = new InnerRequest(
  userClient,
  userClient.getUserList
);
//    角色列表
export const getListUserGroupByTypeRequest = new InnerRequest(
  authorClient,
  authorClient.listUserGroupByType
);

export const getBatchUpdateUserWorkStatusRequest = new InnerRequest(
  userClient,
  userClient.batchUpdateUserWorkStatus
);
